<template>
<v-autocomplete ref="list" :loading="loading" :value="value" :items="items" item-text="title" item-value="_id" label="حساب بانکی" v-bind="$attrs" v-on="$listeners" :rules="requiredRules" @input="handleInput" no-data-text="اطلاعاتی موجود نیست..."
  :hint="hint" persistent-hint prepend-inner-icon="mdi-bank" @focus="onFocus"/>
</template>

<script>
import vueAxios from '../functions/vueAxios'

export default {
  name: 'MyBankaccounts',

  inheritAttrs: false,

  props: {
    value: {
      required: true,
    },

    type: {
      type: String,
      default: 'bankReceipt',
    },

    refs: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      items: [],
      requestId: 0,

      requiredRules: [
        v => !!v || 'الزامی',
      ],
    }
  },

  computed: {
    hint() {
      const found = this.items.find(
        item => String(item._id) === String(this.value)
      )

      return found ? found.number : ''
    },
  },

  methods: {
    async retrieveData() {
      this.loading = true
      const id = ++this.requestId

      try {
        const res = await vueAxios.get('/bank_accounts/name')

        if (this.requestId !== id) return

        const rows = Array.isArray(res) ?
          res :
          Array.isArray(res && res.data) ?
          res.data : []

        this.items = rows.map(item => ({
          // API فعلی فیلد id را برمی‌گرداند.
          _id: item._id || item.id,

          title: `(${item.id})(${item.bank}) - ${item.owner}`,

          id: item.id,
          bank: item.bank,
          owner: item.owner,
          number: item.number,
          sheba: item.sheba,
          branch: item.branch,
          national_code: item.national_code,
        }))
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(e)
        }
      } finally {
        if (this.requestId === id) {
          this.loading = false
        }
      }
    },

    handleInput(value) {
      this.$emit('input', value)

      const selected = this.items.find(
        item => String(item._id) === String(value)
      )

      this.$emit('selected', selected || null)
    },

    setDefaultIfNeeded() {
      if (this.value || !this.items.length) return

      const defaultIndex = {
        bankReceipt: 0,
        pos: 3,
      }

      const idx = Math.min(
        defaultIndex[this.type] ?? 0,
        this.items.length - 1
      )

      const item = this.items[idx]

      if (item) {
        this.$emit('input', item._id)
        this.$emit('selected', item)
      }
    },

    focusAndSelect() {
      setTimeout(() => {
        if (this.$refs.list) {
          this.$refs.list.focus()
        }

        const inputEl = this.$refs.list &&
          this.$refs.list.$el.querySelector('input')

        if (inputEl) {
          inputEl.select()
        }
      }, 50)
    },

    onFocus() {
      this.setDefaultIfNeeded()
      this.focusAndSelect()
    },
  },

  async created() {
    await this.retrieveData()

    if (this.refs) {
      this.onFocus()
    }
  },
}
</script>
